import React, { useEffect, useState, useRef } from "react";
import FilterByForDashboard from "../FilterByForDashboard";
import { useGlobalContext } from "../../../context/GlobalContext";
import {
  getDayOfWeekChart,
  getUsePerDayChartData,
  getWeekPartChart,
  getTimeOfDayChart,
  getHmlCoasterChartData,
  getHmlChartData,
} from "../../../services/dashboard/frequency";
import {
  getUsePerDayAndWeekChartDataForCoaster,
  getDayOfWeekAndWeekPartChartForCoaster,
  getTimeOfDayChartForCoaster,
} from "../../../services/dashboard/frequency";
import UsesPerDay from "./frequencyComponents/UsesPerDay";
import UsesPerWeek from "./frequencyComponents/UsesPerWeek";
import TimeOfDay from "./frequencyComponents/TimeOfDay";
import DayOfWeek from "./frequencyComponents/DayOfWeek";
import WeekPart from "./frequencyComponents/WeekPart";
import { useSelector } from "react-redux";
import {
  BASE_SIZE_MID_VALUE,
  BASE_SIZE_MIN_VALUE,
  COMMON_PAGE_BOTTOM_TEXT,
  PROJECT_ID,
} from "../../../utils/constants";
import { validateCompareObjectValues } from "../../../utils/filterBy/filterBy";
import HMLFrequency from "./frequencyComponents/HMLFrequency";

const Frequency = (props) => {
  const {
    productType = "",
    selectedFilters,
    setSelectedFilters,
    isFilterByApplied,
    setIsFilterByApplied,
    selectedFilterValues,
    setSelectedFilterValues,
    checkedCRCategories: unCheckedCRCategories,
  } = props;
  const [activeOption, setActiveOption] = useState("FILTERBY");
  const [loading, setLoading] = useState(false);
  const {
    device,
    deviceCode,
    category,
    product_id,
    showSidebar,
    mappedCategory,
    project_id,
    isCustomRecruitCategory,
  } = useGlobalContext();
  const [usePerDayGraph, setUsePerDayGraph] = useState("");
  const [usePerWeekGraph, setUsePerWeekGraph] = useState("");
  const [dayOfWeekGraph, setDayOfWeekGraph] = useState("");
  const [weekPartGraph, setWeekPartGraph] = useState("");
  const [timeOfDayGraph, setTimeOfDayGraph] = useState("");
  const { token, user } = useSelector((state) => state.auth);
  const {
    occasionsListData,
    hideFilter: isFilterHide,
    customRecruitCategories,
  } = useSelector((state) => state.dashboard);
  const { filter_week } = useSelector((state) => state.dateRange);
  // const [selectedFilters, setSelectedFilters] = useState({});
  const [selectedBrands, setSelectedBrands] = useState([]);
  const [selectedGenders, setSelectedGenders] = useState([]);
  const [selectedOccasions, setSelectedOccasions] = useState([]);
  const [selectedHouseHoldAge, setSelectedHouseHoldAge] = useState([]);
  const [selectedHouseHoldIncome, setSelectedHouseHoldIncome] = useState([]);
  const [selectedHouseHoldSize, setSelectedHouseHoldSize] = useState([]);
  const [selectedHouseHoldChildren, setSelectedHouseHoldChildren] = useState(
    [],
  );
  const [selectedHouseHoldRaceEthnicity, setSelectedHouseHoldRaceEthnicity] =
    useState([]);
  const [selectedForms, setSelectedForms] = useState([]);
  const [selectedDayPart, setSelectedDayPart] = useState([]);
  const [selectedWeekPart, setSelectedWeekPart] = useState([]);
  const [selectedTimeOfDay, setSelectedTimeOfDay] = useState([]);
  const [activeButtonTimeOfDay, setActiveButtonTimeOfDay] =
    useState("% OF TOTAL");
  const [timeOfDayLoader, setTimeOfDayLoader] = useState(false);
  const [activeButtonDayOfWeek, setActiveButtonDayOfWeek] =
    useState("% OF TOTAL");
  const [dayOfWeekLoader, setDayOfWeekLoader] = useState(false);
  const [activeButtonWeekPart, setActiveButtonWeekPart] =
    useState("% OF TOTAL");
  const [weekPartLoader, setWeekPartLoader] = useState(false);
  const [hmlLoader, setHmlLoader] = useState(false);
  const [filterByApply, setFilterByApply] = useState(false);
  // const [isFilterHide, setIsFilterHide] = useState(hideFilter);
  const [hmlGraph, setHmlGraph] = useState("");

  const getSelectedCategory = () => {
    if (selectedHouseHoldAge.length > 0) {
      return "age";
    }
    if (selectedHouseHoldIncome.length > 0) {
      return "income";
    }
    if (selectedHouseHoldSize.length > 0) {
      return "size";
    }
    if (selectedHouseHoldChildren.length > 0) {
      return "children";
    }
    if (selectedHouseHoldRaceEthnicity.length > 0) {
      return "raceEthnicity";
    }
    return "";
  };

  const getSelectedCategoriesString = () => {
    const categories = [];

    if (selectedHouseHoldAge.length > 0) {
      categories.push("age");
    }
    if (selectedHouseHoldIncome.length > 0) {
      categories.push("income");
    }
    if (selectedHouseHoldSize.length > 0) {
      categories.push("size");
    }
    if (selectedHouseHoldChildren.length > 0) {
      categories.push("children");
    }
    if (selectedHouseHoldRaceEthnicity.length > 0) {
      categories.push("raceEthnicity");
    }

    return categories.join("|");
  };

  const requestBodyForSensor = () => {
    let sensorPayload = {
      compare_with: props?.selectedComparitionBy,
      compare_by: props?.compareBy,
      chart_type: "how_often",
      occasion_question_id:
        occasionsListData?.question_id !== ""
          ? parseInt(occasionsListData?.question_id)
          : 0,
      filter_occasion: selectedOccasions.join("|"),
      filter_household: isFilterByApplied
        ? selectedFilterValues?.houseHold
          ? Object.values(selectedFilterValues?.houseHold)
              .flat()
              .map((item) => item.uniques.trim())
              .filter((value) => value !== "All") // Remove "All" if present
              .join("|")
          : ""
        : "",
      filter_household_type: getSelectedCategoriesString(),
      filter_consumer_segment: "",
      filter_product_category: parseInt(product_id),
      filter_product_type: productType,
      filter_brand:
        props?.selectedComparitionBy !== "brand"
          ? selectedBrands.join("|")
          : "",
      filter_form:
        props?.selectedComparitionBy !== "form" ? selectedForms.join("|") : "",
      filter_day_part: selectedDayPart.join("|"),
      filter_week_part: selectedWeekPart.join("|"),
      graph_type: "total_average",
      project_id: parseInt(project_id),
      section_type:
        props?.chooseComparison && validateCompareObjectValues(props?.compareBy)
          ? "compare"
          : "filter",
      mapped_category: mappedCategory,
      filter_week: filter_week,
    };

    if (customRecruitCategories && customRecruitCategories?.length) {
      let checkedCatData = customRecruitCategories?.filter(
        (val) => !unCheckedCRCategories.some((cat) => cat.id === val.id),
      );
      sensorPayload.mapped_category_arr = checkedCatData?.length
        ? checkedCatData?.map((data) => data?.mapped_category)
        : [];
      sensorPayload.product_ids_arr = checkedCatData?.length
        ? checkedCatData?.map((data) => data?.id)
        : [];
    }
    return sensorPayload;
  };

  const fetchChartsDataForSensor = () => {
    setLoading(true);
    Promise.all([
      getUsePerDayChartData(
        { ...requestBodyForSensor(), how_often_use_per: "day" },
        token,
      ),
      getUsePerDayChartData(
        { ...requestBodyForSensor(), how_often_use_per: "week" },
        token,
      ),
    ])
      .then(([usePerDayResponse, usePerWeekResponse]) => {
        setUsePerDayGraph(usePerDayResponse.data.graphs);
        setUsePerWeekGraph(usePerWeekResponse.data.graphs);
      })
      .catch((error) => {
        console.error("Error fetching chart data:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const fetchWeekPartChartDataSensor = async () => {
    try {
      setWeekPartLoader(true);
      const response = await getWeekPartChart(
        {
          ...requestBodyForSensor(),
          graph_type: "weekly_average",
          how_often_use_per: "",
          sub_graph_type:
            activeButtonWeekPart === "% OF TOTAL"
              ? "percentage_of_total"
              : "number_of_usage",
        },
        token,
      );
      setWeekPartGraph(response.data.graphs);
    } catch (error) {
      console.error("Error fetching chart data:", error);
    } finally {
      setWeekPartLoader(false);
    }
  };

  const fetchDayOfWeekChartDataSensor = async () => {
    try {
      setDayOfWeekLoader(true);
      const response = await getDayOfWeekChart(
        {
          ...requestBodyForSensor(),
          graph_type: "daily_average",
          how_often_use_per: "",
          sub_graph_type:
            activeButtonDayOfWeek === "% OF TOTAL"
              ? "percentage_of_total"
              : "number_of_usage",
        },
        token,
      );
      setDayOfWeekGraph(response.data.graphs);
    } catch (error) {
      console.error("Error fetching chart data:", error);
    } finally {
      setDayOfWeekLoader(false);
    }
  };

  const fetchTimeOfDayChartDataSensor = async () => {
    try {
      setTimeOfDayLoader(true);
      const response = await getTimeOfDayChart(
        {
          ...requestBodyForSensor(),
          graph_type: "day_average",
          how_often_use_per: "",
          sub_graph_type:
            activeButtonTimeOfDay === "% OF TOTAL"
              ? "percentage_of_total"
              : "number_of_usage",
        },
        token,
      );
      setTimeOfDayGraph(response.data.graphs);
    } catch (error) {
      console.error("Error fetching chart data:", error);
    } finally {
      setTimeOfDayLoader(false);
    }
  };

  const requestBodyForCoaster = {
    compare_with: props?.selectedComparitionBy,
    compare_by: props?.compareBy,
    chart_type: "",
    filter_occasion: selectedOccasions.join("|"),
    filter_household: isFilterByApplied
      ? selectedFilterValues?.houseHold
        ? Object.values(selectedFilterValues?.houseHold)
            .flat()
            .map((item) => item.uniques.trim())
            .filter((value) => value !== "All") // Remove "All" if present
            .join("|")
        : ""
      : "",
    filter_household_type: getSelectedCategoriesString(),
    filter_consumer_segment: "",
    filter_product_category: parseInt(product_id),
    filter_product_type: productType,
    filter_brand:
      props?.selectedComparitionBy !== "brand" ? selectedBrands.join("|") : "",
    filter_form:
      props?.selectedComparitionBy !== "form" ? selectedForms.join("|") : "",
    filter_day_part: selectedDayPart.join("|"),
    filter_week_part: selectedWeekPart.join("|"),
    graph_type: "no_of_use",
    how_long_use_per: "",
    project_id: parseInt(project_id),
    cat_id: parseInt(product_id),
    cat_name: category,
    section_type:
      props?.chooseComparison && validateCompareObjectValues(props?.compareBy)
        ? "compare"
        : "filter",
    how_often_use_per: "",
    filter_week: filter_week,
  };

  const fetchChartsDataForCoaster = () => {
    setLoading(true);

    Promise.all([
      getUsePerDayAndWeekChartDataForCoaster(
        { ...requestBodyForCoaster, day_type: "day" },
        token,
      ),
      getUsePerDayAndWeekChartDataForCoaster(
        { ...requestBodyForCoaster, day_type: "week" },
        token,
      ),
    ])
      .then(([usePerDayResponse, usePerWeekResponse]) => {
        setUsePerDayGraph(usePerDayResponse.data.graphs);
        setUsePerWeekGraph(usePerWeekResponse.data.graphs);
      })
      .catch((error) => {
        console.error("Error fetching chart data:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const fetchDayOfWeekChartDataCoaster = async () => {
    try {
      setDayOfWeekLoader(true);
      const response = await getDayOfWeekAndWeekPartChartForCoaster(
        {
          ...requestBodyForCoaster,
          day_type: "day",
          how_often_use_per: "",
          chart_type: "how_often",
          sub_graph_type:
            activeButtonDayOfWeek === "% OF TOTAL"
              ? "percentage_of_total"
              : "number_of_usage",
        },
        token,
      );
      setDayOfWeekGraph(response.data.graphs);
    } catch (error) {
      console.error("Error fetching chart data:", error);
    } finally {
      setDayOfWeekLoader(false);
    }
  };

  const fetchWeekPartChartDataCoaster = async () => {
    try {
      setWeekPartLoader(true);
      const response = await getDayOfWeekAndWeekPartChartForCoaster(
        {
          ...requestBodyForCoaster,
          day_type: "week",
          how_often_use_per: "",
          chart_type: "how_often",
          sub_graph_type:
            activeButtonWeekPart === "% OF TOTAL"
              ? "percentage_of_total"
              : "number_of_usage",
        },
        token,
      );
      setWeekPartGraph(response.data.graphs);
    } catch (error) {
      console.error("Error fetching chart data:", error);
    } finally {
      setWeekPartLoader(false);
    }
  };

  const fetchTimeOfDayChartDataCoaster = async () => {
    try {
      setTimeOfDayLoader(true);
      const response = await getTimeOfDayChartForCoaster(
        {
          ...requestBodyForCoaster,
          how_often_use_per: "",
          sub_graph_type:
            activeButtonTimeOfDay === "% OF TOTAL"
              ? "percentage_of_total"
              : "number_of_usage",
        },
        token,
      );
      setTimeOfDayGraph(response.data.graphs);
    } catch (error) {
      console.error("Error fetching chart data:", error);
    } finally {
      setTimeOfDayLoader(false);
    }
  };

  const fetchHmlChartData = async () => {
    try {
      setHmlLoader(true);
      let response;
      if (deviceCode === 1) {
        response = await getHmlCoasterChartData(
          {
            ...requestBodyForCoaster,
            graph_type: "hml_average",
            how_often_use_per: "week",
            sub_graph_type: "number_of_usage",
          },
          token,
        );
      } else {
        response = await getHmlChartData(
          {
            ...requestBodyForSensor(),
            graph_type: "hml_average",
            how_often_use_per: "week",
            sub_graph_type: "number_of_usage",
          },
          token,
        );
      }

      setHmlGraph(response.data.graphs);
    } catch (error) {
      console.error("Error fetching chart data:", error);
    } finally {
      setHmlLoader(false);
    }
  };

  useEffect(() => {
    if (productType !== "" && parseInt(deviceCode) !== 1) {
      fetchChartsDataForSensor();
      fetchHmlChartData();
    }
  }, [productType, props?.apply, filterByApply, filter_week, props?.compareBy]);

  useEffect(() => {
    if (parseInt(deviceCode) === 1) {
      fetchChartsDataForCoaster();
      fetchHmlChartData();
    }
  }, [deviceCode, props?.apply, filterByApply, filter_week, props?.compareBy]);

  useEffect(() => {
    if (productType !== "" && parseInt(deviceCode) !== 1) {
      fetchTimeOfDayChartDataSensor();
    }
  }, [
    productType,
    props?.apply,
    filterByApply,
    activeButtonTimeOfDay,
    filter_week,
    props?.compareBy,
  ]);

  useEffect(() => {
    if (productType !== "" && parseInt(deviceCode) !== 1) {
      fetchDayOfWeekChartDataSensor();
    }
  }, [
    productType,
    props?.apply,
    filterByApply,
    activeButtonDayOfWeek,
    filter_week,
    props?.compareBy,
  ]);

  useEffect(() => {
    if (productType !== "" && parseInt(deviceCode) !== 1) {
      fetchWeekPartChartDataSensor();
    }
  }, [
    productType,
    props?.apply,
    filterByApply,
    activeButtonWeekPart,
    filter_week,
    props?.compareBy,
  ]);

  useEffect(() => {
    if (deviceCode === 1) {
      fetchDayOfWeekChartDataCoaster();
    }
  }, [
    deviceCode,
    props?.apply,
    filterByApply,
    activeButtonDayOfWeek,
    filter_week,
    props?.compareBy,
  ]);

  useEffect(() => {
    if (deviceCode === 1) {
      fetchWeekPartChartDataCoaster();
    }
  }, [
    deviceCode,
    props?.apply,
    filterByApply,
    activeButtonWeekPart,
    filter_week,
    props?.compareBy,
  ]);

  useEffect(() => {
    if (deviceCode === 1) {
      fetchTimeOfDayChartDataCoaster();
    }
  }, [
    deviceCode,
    props?.apply,
    filterByApply,
    activeButtonTimeOfDay,
    filter_week,
    props?.compareBy,
  ]);

  useEffect(() => {
    if (props?.selectedComparitionBy === "brand") {
      setSelectedBrands([]);
    }
    if (props?.selectedComparitionBy === "form") {
      setSelectedForms([]);
    }
    if (props?.selectedComparitionBy === "household") {
      setSelectedFilters({});
    }
  }, [props?.selectedComparitionBy]);

  useEffect(() => {
    setSelectedDayPart([]);
    setSelectedWeekPart([]);
    setSelectedBrands([]);
    setSelectedOccasions([]);
    // setSelectedFilters({});
    setSelectedForms([]);
  }, [parseInt(product_id)]);

  const handleReset = () => {
    setSelectedDayPart([]);
    setSelectedWeekPart([]);
    setSelectedBrands([]);
    setSelectedOccasions([]);
    setSelectedFilters({});
    setSelectedForms([]);
    setFilterByApply(!filterByApply);
    setIsFilterByApplied(false);
    setSelectedFilterValues({});
  };

  const handleFilterApply = () => {
    setSelectedFilterValues((prevProp) => {
      return {
        ...prevProp,
        houseHold: selectedFilters,
      };
    });
  };

  return (
    <div className="row" style={{ position: "relative" }}>
      {/* {user?.type === "superadmin" ? ( */}
      <FilterByForDashboard
        loading={loading}
        setLoading={setLoading}
        device={device}
        deviceCode={deviceCode}
        category={category}
        product_id={product_id}
        productType={productType}
        activeOption={activeOption}
        setActiveOption={setActiveOption}
        frequency={true}
        selectedForms={selectedForms}
        setSelectedForms={setSelectedForms}
        selectedBrands={selectedBrands}
        setSelectedBrands={setSelectedBrands}
        selectedGenders={selectedGenders}
        setSelectedGenders={setSelectedGenders}
        selectedOccasions={selectedOccasions}
        setSelectedOccasions={setSelectedOccasions}
        selectedHouseHoldAge={selectedHouseHoldAge}
        setSelectedHouseHoldAge={setSelectedHouseHoldAge}
        selectedHouseHoldIncome={selectedHouseHoldIncome}
        setSelectedHouseHoldIncome={setSelectedHouseHoldIncome}
        selectedHouseHoldSize={selectedHouseHoldSize}
        setSelectedHouseHoldSize={setSelectedHouseHoldSize}
        selectedHouseHoldChildren={selectedHouseHoldChildren}
        setSelectedHouseHoldChildren={setSelectedHouseHoldChildren}
        selectedHouseHoldRaceEthnicity={selectedHouseHoldRaceEthnicity}
        setSelectedHouseHoldRaceEthnicity={setSelectedHouseHoldRaceEthnicity}
        selectedDayPart={selectedDayPart}
        setSelectedDayPart={setSelectedDayPart}
        selectedWeekPart={selectedWeekPart}
        setSelectedWeekPart={setSelectedWeekPart}
        selectedTimeOfDay={selectedTimeOfDay}
        setSelectedTimeOfDay={setSelectedTimeOfDay}
        apply={filterByApply}
        setApply={(filterByflagValue) => {
          setFilterByApply(filterByflagValue);
          setIsFilterByApplied(true);
          handleFilterApply();
        }}
        isCompareByClicked={props?.isCompareByClicked}
        setIsCompareByClicked={props?.setIsCompareByClicked}
        setSelectedFilters={setSelectedFilters}
        selectedFilters={selectedFilters}
        isDayWeekPartShow={true}
        handleReset={handleReset}
        // setIsFilterHide={(toggle) => setIsFilterHide(toggle)}
        selectedComparitionBy={props?.selectedComparitionBy}
        mappedCategory={mappedCategory}
      />
      {/* ) : (
        ""
      )} */}
      <div
        className={isFilterHide ? `col-12` : `col-9`}
        style={{ padding: "0px 3%" }}
      >
        <UsesPerDay
          usePerDayGraph={usePerDayGraph}
          loading={loading}
          isFilterHide={isFilterHide}
          showSidebar={showSidebar}
        />
        <UsesPerWeek
          usePerWeekGraph={usePerWeekGraph}
          loading={loading}
          isFilterHide={isFilterHide}
          showSidebar={showSidebar}
        />
        <TimeOfDay
          activeButtonTimeOfDay={activeButtonTimeOfDay}
          setActiveButtonTimeOfDay={setActiveButtonTimeOfDay}
          timeOfDayGraph={timeOfDayGraph}
          timeOfDayLoader={timeOfDayLoader}
          isFilterHide={isFilterHide}
          showSidebar={showSidebar}
        />
        <DayOfWeek
          activeButtonDayOfWeek={activeButtonDayOfWeek}
          setActiveButtonDayOfWeek={setActiveButtonDayOfWeek}
          dayOfWeekGraph={dayOfWeekGraph}
          dayOfWeekLoader={dayOfWeekLoader}
          isFilterHide={isFilterHide}
          showSidebar={showSidebar}
        />
        <WeekPart
          activeButtonWeekPart={activeButtonWeekPart}
          setActiveButtonWeekPart={setActiveButtonWeekPart}
          weekPartGraph={weekPartGraph}
          weekPartLoader={weekPartLoader}
          isFilterHide={isFilterHide}
          showSidebar={showSidebar}
        />
        <HMLFrequency
          hmlGraph={hmlGraph}
          hmlLoader={hmlLoader}
          isFilterHide={isFilterHide}
          showSidebar={showSidebar}
        />

        <div
          className="text-light-gray text-start mb-3"
          style={{
            fontSize: "12px",
            fontWeight: "bold",
          }}
        >
          {/* {COMMON_PAGE_BOTTOM_TEXT} */}
          <div>{`*Low sample (n<${BASE_SIZE_MIN_VALUE} products)`}</div>
          <div>{`^Directional Use Only (n=${BASE_SIZE_MID_VALUE} products)`}</div>
        </div>
      </div>
    </div>
  );
};

export default Frequency;
